import { Component } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'carm-table-ag-header-actions-tooltip',
  templateUrl: './table-ag-header-actions-tooltip.component.html',
  styleUrls: ['./table-ag-header-actions-tooltip.component.scss'],
})
export class TableAgHeaderActionsTooltipComponent implements IHeaderAngularComp {

  params: any;
  tootipContent: string;
  iconColor = '#26374a';
  showOnHover = false;

  constructor(
    private translateService: TranslateService,
  ) {
  }

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.tootipContent = this.translateService.instant(this.params.tooltip);
  }

  refresh(): boolean {
    return false;
  }
}
